import * as firebase from 'firebase/app'
import * as React from 'react'

import { IClient } from 'interfaces/IClient'
import { IInvoice } from 'interfaces/IInvoice'

class Importer extends React.Component {
  public invoices: HTMLInputElement | null

  public handleImport = () => {
    if (!this.invoices || !this.invoices.files || !this.invoices.files[0]) {
      return alert('Saknar fakturor')
    }

    const reader = new FileReader()
    reader.readAsText(this.invoices.files[0])
    reader.onload = e => {
      const target = e.target as FileReader

      if (target && target.result && typeof target.result === 'string') {
        try {
          const data: {
            invoices: IInvoice[]
            clients: { [id: string]: IClient }
          } = JSON.parse(target.result)

          const { currentUser } = firebase.auth()

          if (!currentUser) {
            throw new Error('Not Logged in')
          }

          // tslint:disable-next-line:no-console
          console.info(data)

          const clientKeys = {}

          Object.keys(data.clients).forEach(id => {
            const client = firebase
              .database()
              .ref(`/clients/${currentUser.uid}/`)
              .push(data.clients[id])

            clientKeys[id] = client.key
          })

          data.invoices.forEach(invoice => {
            firebase
              .database()
              .ref(`/invoices/${currentUser.uid}/`)
              .push({
                ...invoice,
                clientKey: clientKeys[invoice.clientKey],
              })
          })

          // tslint:disable-next-line:no-console
          console.info(data)
        } catch (err) {
          // tslint:disable-next-line:no-console
          console.error(err)
        }
      }
    }
  }

  public render() {
    return (
      <div>
        <h1>Importer</h1>
        <div>
          <h2>Fakturor</h2>
          <input type="file" ref={node => (this.invoices = node)} />
        </div>
        <div>
          <button className="button" onClick={this.handleImport}>
            <span>Importera</span>
          </button>
        </div>
      </div>
    )
  }
}

export default Importer



// WEBPACK FOOTER //
// ./src/containers/Importer/Importer.tsx